const DATA_SAVED = "extragestor/ventasContactos/DATA_SAVED";
const RESET_DATA_SAVED = "extragestor/ventasContactos/RESET_DATA_SAVED";

const QUITAR_COLEGIO_SELECCIONADO =
  "extragestor/ventasContactos/QUITAR_COLEGIO_SELECCIONADO";
const ADDED_PERSONAS_CONTACTO =
  "extragestor/ventasContactos/ADDED_PERSONAS_CONTACTO";
const REMOVED_PERSONAS_CONTACTO =
  "extragestor/ventasContactos/REMOVED_PERSONAS_CONTACTO";
const CHANGED_PERSONAS_CONTACTO =
  "extragestor/ventasContactos/CHANGED_PERSONAS_CONTACTO";
const LIMPIAR_PERSONAS_CONTACTO =
  "extragestor/ventasContactos/LIMPIAR_PERSONAS_CONTACTO";
const DETACH_LISTENER = "DETACH_LISTENER";

/* --- */
export {
  DATA_SAVED,
  RESET_DATA_SAVED,
  QUITAR_COLEGIO_SELECCIONADO,
  ADDED_PERSONAS_CONTACTO,
  REMOVED_PERSONAS_CONTACTO,
  CHANGED_PERSONAS_CONTACTO,
  LIMPIAR_PERSONAS_CONTACTO,
  DETACH_LISTENER
};



// WEBPACK FOOTER //
// ./src/ducks/ventasContactos/types.js